<template>
  <v-app>
    <v-app-bar app color="primary" fixed dark class="pr-4">
      <!-- <v-spacer></v-spacer>
      <span style="font-size: 9pt;">{{ version }}</span> -->
      <a href="https://worldencadernadora.com.br" title="World Encadernadora">
        <v-img
          max-width="152"
          class="ml-0"
          src="./assets/World-white.png"
        ></v-img>
      </a>

      <v-spacer></v-spacer>

      <!-- MENU  -->
      <v-menu bottom left v-if="verificaAdmin">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-4 secondary" width="36" height="36" dark icon v-bind="attrs" v-on="on">
              <v-icon dense color="accent">mdi-shield-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(itemAdm, i) in itemsAdm"
            :key="i"
            @click="menuAdmClicked(itemAdm.title)"
          >
            <v-list-item-avatar
              ><v-icon color="accent">{{ itemAdm.icon }}</v-icon></v-list-item-avatar
            >
            <v-list-item-title>{{ itemAdm.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- FIM - MENU  -->

      <!-- MENU  -->
      <v-menu bottom left color="primary" v-if="!!user">
        <template v-slot:activator="{ on, attrs }">
          <v-btn width="36" height="36" dark icon v-bind="attrs" v-on="on">
            <div v-if="foto !== ''">
              <v-avatar size="36" color="grey">
                <v-img :src="foto"></v-img>
              </v-avatar>
            </div>
            <div v-else>
              <v-icon size="36" dense color="secondary">mdi-account</v-icon>
            </div>
          </v-btn>
        </template>

        <v-list>
        <v-list-item>
          <v-list-item-title class="primary--text justify-center" style="font-size: 9pt;"><strong class="mr-10">WORLD</strong>{{ version }}</v-list-item-title>
        </v-list-item>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            @click="menuClicked(item.title)"
          >
            <v-list-item-avatar
              ><v-icon>{{ item.icon }}</v-icon></v-list-item-avatar
            >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="menuClicked('Sair')">
            <v-list-item-avatar
              ><v-icon color="red">mdi-power</v-icon></v-list-item-avatar
            >
            <v-list-item-title class="red--text">Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- FIM - MENU  -->
    </v-app-bar>

    <v-main>
      <router-view />
      <v-tooltip left color="primary">
        <template v-slot:activator="{ on, attrs }">
      <v-fab-transition>
        <v-btn
          fab
          dark
          small
          bottom
          right
          v-bind="attrs"
          v-on="on"
          color="primary"
          @click="callWhatsApp()"
          class="fab-button"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>
    <span>Fale com o representante</span>
  </v-tooltip>
    </v-main>

    <v-snackbar
      multi-line
      centered
      :value="updateExists"
      :timeout="-1"
      color="indigo"
    >
      Novo conteúdo disponível para o APP
      <v-btn text @click="refreshApp">
        <v-icon class="mr-2">mdi-autorenew</v-icon>
        atualizar
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="alert = false">
          X
        </v-btn>
      </template>
    </v-snackbar>

  </v-app>
</template>

<script>
import update from "./mixins/update";

export default {
  name: "App",
  computed: {
    version() {
      return this.$store.getters.version;
    },
    user() {
      return this.$store.getters.user;
    },
    autorizados() {
      return this.$store.getters.autorizados;
    },
    verificaAdmin() {
      return this.$store.getters.verificaAdmin;
    },
  },
  watch: {
    user (u) {
      if (u !== undefined && Object.keys(u).length > 0) {
        if (u.foto) {
          this.foto = u.foto;
        } else {
          this.foto = '';
        }
        console.log(!!this.foto)
      }
    },
    verificaAdmin(a) {
      console.log(a)
    }
  },
  mixins: [update],
  data: () => ({
    online: navigator.onLine,
    msg: "",
    alert: false,
    drawer: false,
    group: null,
    deferredPrompt: null,
    foto: "",
    iconFoto: "mdi-account",
    items: [
      { title: "Meus dados", icon: "mdi-account-edit" },
      { title: "Calcular", icon: "mdi-calculator" },
      { title: "Orçamentos", icon: "mdi-format-list-numbered" },
    ],
    itemsAdm: [
      { title: "Admin", icon: "mdi-shield" },
      { title: "Orçamentos", icon: "mdi-format-list-numbered" },
      { title: "Envio de fotos", icon: "mdi-image" },
    ],
  }),
  created() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
    });
  },
  mounted() {
    if (!this.online) {
      this.showAlert("Você está offline.");
    }
    if (this.verificaAdmin) {
      this.$store.dispatch("loadUsers");
    }
  },
  destroyed() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    showAlert(msg) {
        this.msg = msg
        this.alert = true;
      },
    updateOnlineStatus() {
      this.online = navigator.onLine;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    callWhatsApp() {
      const phone = '+5511975049324';
      window.open(`https://wa.me/${phone}`, '_blank');
    },
    logOut() {
      this.$store.dispatch("logOut");
      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
    menuClicked(e) {
      if (e === "Meus dados") {
        if (this.$route.path !== "/perfil") {
          // this.$store.dispatch("loadUser");
          this.$router.push("/perfil");
        }
      }
      if (e === "Calcular") {
        if (this.$route.path !== "/") {
          this.$store.dispatch("loadImagens");
          this.$router.push("/");
        }
      }
      if (e === "Orçamentos") {
        if (this.$route.path !== "/my_list") {
          this.$store.dispatch("loadCalcsUser", this.user.uid);
          this.$router.push("/my_list");
        }
      }
      if (e === "Sair") {
        this.logOut();
      }
    },
    menuAdmClicked(e) {
      if (e === "Orçamentos") {
        if (this.$route.path !== "/lista") {
          this.$store.dispatch("loadAutorizados");
          this.$store.dispatch('setVerificaAdmin', {uid:this.user.uid, admins:this.autorizados})
          this.$store.dispatch("loadCalcs");
          this.$router.push("/lista");
        }
      }
      if (e === "Admin") {
        if (this.$route.path !== "/admin") {
          this.$store.dispatch("loadAutorizados");
          this.$store.dispatch('setVerificaAdmin', {uid:this.user.uid, admins:this.autorizados});
          this.$store.dispatch("loadPrecosCm2");
          this.$store.dispatch("loadImagens");
          this.$store.dispatch("loadUsers");
          this.$router.push("/admin");
        }
      }
      if (e === "Envio de fotos") {
        this.$store.dispatch("loadAutorizados");
        this.$store.dispatch('setVerificaAdmin', {uid:this.user.uid, admins:this.autorizados});
        this.$router.push("/envios");
      }
    },
  },
};
</script>

<style scoped>
  .fab-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;
  }
</style>